import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Avatar, useTheme } from "@mui/material";
import clsx from "clsx";
import { useState } from "react";
import { useStyles } from "./styles";
import { MemberAvatarProps } from "./types";
import { getMemberInitials, resolveThemeColor } from "./utils";

function MemberAvatar({ member, bgcolor }: MemberAvatarProps) {
  const theme = useTheme();
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const email = member?.email;

  const handleCopy = (event) => {
    event.stopPropagation();
    if (!email) return;

    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Avatar
      title={copied ? "Copied to clipboard" : email}
      classes={{
        root: clsx(
          classes.memberAvatar,
          email && classes.memberAvatarClickable
        ),
      }}
      style={{ backgroundColor: resolveThemeColor(theme, bgcolor) }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {getMemberInitials(member)}
      {email && (
        <div
          className={clsx(
            classes.memberAvatarCopy,
            isHovered && classes.memberAvatarCopyVisible
          )}
          onClick={handleCopy}
        >
          {copied ? (
            <CheckIcon classes={{ root: classes.memberAvatarCopyIcon }} />
          ) : (
            <ContentCopyIcon classes={{ root: classes.memberAvatarCopyIcon }} />
          )}
        </div>
      )}
    </Avatar>
  );
}

export { MemberAvatar };
